import { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Avatar from '@material-ui/core/Avatar';

import {
  Copper, DarkGray, LightGray, MediumGray
} from './Styles';
import debounce from '../helpers/debounce';
import LinkButton from './LinkButton';
import minusIcon from '../containers/img/round-remove_circle_medium_green.svg';
import plusIcon from '../containers/img/round-add_circle_medium_green.svg';
import ProductAvatar from './ProductAvatar';

const OrderProduct = ({
  orderProduct,
  productCategory,
  showProductPrice,
  editable,
  adjustable,
  to,
  onChange,
}) => {
  const [counter, setCounter] = useState(Number(orderProduct.requested_quantity));
  useEffect(() => {
    setCounter(Number(orderProduct.requested_quantity));
  }, [orderProduct]);
  return (
    <div css={{
      display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem', paddingBottom: '1rem', borderBottom: `1px solid ${LightGray}`,
    }}
    >
      <div css={{ flex: 1 }}>
        <ProductAvatar
          product={orderProduct.product}
          productCategory={productCategory}
        />
      </div>
      <div css={{ flex: 2 }}>
        { to
          ? (
            <LinkButton
              style={{
                margin: '0px',
                fontSize: '1.1rem',
                padding: '0px',
              }}
              to={to}
            >
              {orderProduct.product.name}
            </LinkButton>
          )
          : (
            <div>
              {orderProduct.product.name}
            </div>
          )}
        { showProductPrice
          ? <div css={{ color: MediumGray, fontSize: '1rem' }}>${parseFloat(orderProduct.price).toFixed(2)} / {orderProduct.unit}</div>
          : <div css={{ color: '#666666', fontSize: '1rem' }}>{orderProduct.product.vendor.name}</div>}
      </div>
      <div css={{ flex: 1, textAlign: 'right' }}>
        <div>
          { editable
            ? (
              <div css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Avatar
                  css={{ height: '20px', width: '20px' }}
                  src={minusIcon}
                  onClick={() => {
                    const q = Math.max(counter - 1, 0);
                    setCounter(q);
                    debounce(
                      orderProduct.product.id,
                      () => {
                        onChange({
                          ...orderProduct,
                          requested_quantity: q,
                        });
                      },
                      1000,
                    );
                  }}
                />
                <div css={{
                  textAlign: 'center', width: '25px', color: DarkGray, fontSize: '1.1rem',
                }}
                >
                  {counter || '0'}
                </div>
                <Avatar
                  css={{ height: '20px', width: '20px' }}
                  src={plusIcon}
                  onClick={() => {
                    const q = counter + 1;
                    setCounter(q);
                    debounce(
                      orderProduct.product.id,
                      () => {
                        onChange({
                          ...orderProduct,
                          requested_quantity: q,
                        });
                      },
                      1000,
                    );
                  }}
                />
              </div>
            ) : orderProduct.requested_quantity}
        </div>
      </div>
      { adjustable
        && (
        <div css={{ flex: 1, textAlign: 'right' }}>
          <div>
            <TextField
              id="email"
              InputProps={{ type: 'number' }}
              value={orderProduct.filled_quantity || ''}
              css={{ width: '3rem' }}
              onChange={(e) => onChange({
                ...orderProduct,
                filled_quantity: Math.abs(parseFloat(e.target.value) || 0),
              })}
            />
          </div>
          <div css={{ color: '#666666', fontSize: '1rem' }}>
            {orderProduct.unit}
          </div>
        </div>
        )}
      <div css={{
        flex: 1, textAlign: 'right', color: Copper, fontSize: '1rem',
      }}
      >
        { adjustable
          ? `$${(orderProduct.filled_quantity * orderProduct.price).toFixed(2)}`
          : `$${(orderProduct.requested_quantity * orderProduct.price).toFixed(2)}`}
      </div>
    </div>
  );
};

export default OrderProduct;
